import {BooleanFilterConfig} from '@shared/components/filters/SelectFilter';

export const LIVE_STATUS_FILTER: BooleanFilterConfig = {
  placeholder: 'Live Status',
  options: [
    {value: null, label: 'Live Status'},
    {value: true, label: 'Live'},
    {value: false, label: 'Not live'},
  ],
};

export const ACTIVATION_STATUS_FILTER: BooleanFilterConfig = {
  placeholder: 'Activation status',
  options: [
    {value: null, label: 'Activation status'},
    {value: true, label: 'Activated'},
    {value: false, label: 'Not activated'},
  ],
};

export const STATUS_FILTER: BooleanFilterConfig = {
  placeholder: 'Status',
  options: [
    {value: null, label: 'Status'},
    {value: true, label: 'Coming soon'},
    {value: false, label: 'Active'},
  ],
};

export const BANNER_STATUS_FILTER: BooleanFilterConfig = {
  placeholder: 'Status',
  options: [
    {value: null, label: 'All'},
    {value: true, label: 'Active'},
  ],
};
